import styled from 'styled-components';

// Import components
import { Button, PlayerElements as Player } from 'components/elements';

export const Wrapper = styled.div`
	position: absolute;
	padding: 2rem 0 2rem 3rem;
	display: flex;
	align-items: center;
	opacity: ${({ isFocus }) => (isFocus ? 1 : 0)};
	visibility: ${({ isFocus }) => (isFocus ? 'visible' : 'hidden')};
	transition: all 0.3s ease-in-out;
	z-index: 900;
	left: 0;
	bottom: ${({ isControllers }) => (isControllers ? -1 : 0.4)}rem;
	width: 100%;
`;

export const VolumeStyled = styled(Player.Volume)`
	position: absolute;
	top: -7rem;
	left: -3.5rem;
	height: 0.5rem;
	transform: rotate(-90deg);
`;

export const StyledButton = styled(Button)`
	margin-right: 1.5rem;
`;
